var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main"}},[_c('div',{staticClass:"fof"},[_c('h1',[_vm._v("Error 404")]),_c('div',[_vm._v("Pagina niet gevonden")]),_c('br')])])
}]

export { render, staticRenderFns }